import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import React from 'react';
import KYCDocumentsTable, { KYCDocument } from './KYCDocumentsTable';

interface AWBKYCTabProps {
  customerDocuments?: KYCDocument[];
  onCustomerDocsChange?: (docs: KYCDocument[]) => void;
  shipperDocuments: KYCDocument[];
  onShipperDocsChange: (docs: KYCDocument[]) => void;
  consigneeDocuments: KYCDocument[];
  onConsigneeDocsChange: (docs: KYCDocument[]) => void;
  onSave: () => void;
  isSaving: boolean;
  readOnly?: boolean;
}

const AWBKYCTab: React.FC<AWBKYCTabProps> = ({
  customerDocuments = [],
  onCustomerDocsChange,
  shipperDocuments,
  onShipperDocsChange,
  consigneeDocuments,
  onConsigneeDocsChange,
  onSave,
  isSaving,
  readOnly = false,
}) => {
  return (
    <div className='space-y-6'>
      <Card>
        <CardContent className='p-6 space-y-8'>
          {/* Customer KYC Section - Documents saved to Customer Master */}
          <KYCDocumentsTable
            sectionTitle='I. CUSTOMER'
            sectionSubtitle='DOCUMENT UPLOADED HERE ARE SAVE IN CUSTOMER MASTER'
            documents={customerDocuments}
            onChange={onCustomerDocsChange || (() => {})}
            readOnly={readOnly || !onCustomerDocsChange}
          />

          {/* Shipper KYC Section - Documents at docket level */}
          <KYCDocumentsTable
            sectionTitle='II. SHIPPER (DOCKET LEVEL)'
            documents={shipperDocuments}
            onChange={onShipperDocsChange}
            readOnly={readOnly}
          />

          {/* Consignee KYC Section - Documents at docket level */}
          <KYCDocumentsTable
            sectionTitle='III. CONSIGNEE (DOCKET LEVEL)'
            documents={consigneeDocuments}
            onChange={onConsigneeDocsChange}
            readOnly={readOnly}
          />

          {!readOnly && (
            <div className='flex justify-end'>
              <Button onClick={onSave} disabled={isSaving}>
                {isSaving ? 'Saving...' : 'SAVE KYC'}
              </Button>
            </div>
          )}
        </CardContent>
      </Card>
    </div>
  );
};

export default AWBKYCTab;
